import { render, staticRenderFns } from "./bonusTips.vue?vue&type=template&id=438884a7"
import script from "./bonusTips.vue?vue&type=script&lang=js"
export * from "./bonusTips.vue?vue&type=script&lang=js"
import style0 from "./bonusTips.vue?vue&type=style&index=0&id=438884a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports